import Action from './Action';
import HexCoords from '../grid/HexCoords';
import ActorStats from '../components/ActorStats';
import PlayerControlled from '../components/PlayerControlled';

export default class Conflict {
  public participants: Action[];
  public contestedHex: HexCoords;
  public priority: number = -1;

  constructor(participants: Action[], contestedHex: HexCoords) {
    this.participants = participants;
    this.contestedHex = contestedHex;
  }

  toString() {
    const actionsPart = this.participants.map(a => a.toString()).join(', ')
    return `<Conflict contestedHex:${this.contestedHex.key} [${actionsPart}]>`
  }
}
